﻿(Bookhus || (Bookhus = {}));; // namespace
Bookhus.CatalogBookingcalendar = (function() {
    // private members
    var parameters = {
        minBookingborder: 3,
        mediumBookingborder: 7,
        locale: 'da-DK',
        skipEmptyWeeksThisYear: false,
        skipEmptyWeeksNextYear: false,
        userId: -1,
        maxOccupiedDaysInEmptyWeek: 1
    };

    var countTypesInArray = function (array, value) {
        var cnt = 0;
        for (var i = 0; i < array.length; i++) {
            if (array[i].type === value) {
                cnt++;
            }
        }
        return cnt;
    }

    var isAllTypesInArray = function (array, value, ignoreValue, ignoreValue2) {
        for (var i = 0; i < array.length; i++) {
            if ((array[i].type !== value) && array[i].type !== ignoreValue && array[i].type !== ignoreValue2) {
                return false;
            }
        }
        return true;
    }

    var sortColorclasscollection = function (arr) {
        var cnt = arr['reservation'];
        var name = 'reservation';

        if (arr['drawperiod'] > cnt) {
            name = 'drawperiod';
            cnt = arr['drawperiod'];
        }
        if (arr['locked'] > cnt) {
            name = 'locked';
            cnt = arr['locked'];
        }
        if (arr['booking'] > cnt) {
            name = 'booking';
            cnt = arr['booking'];
        }
        if (arr['bookingmedium'] > cnt) {
            name = 'bookingmedium';
            cnt = arr['bookingmedium'];
        }
        if (arr['bookinghard'] > cnt) {
            name = 'bookinghard';
            cnt = arr['bookinghard'];
        }
        if (arr['reservationbyme'] > cnt) {
            name = 'reservationbyme';
            cnt = arr['reservationbyme'];
        }
        if (arr['empty'] > cnt) {
            name = 'empty';
            cnt = arr['empty'];
        }

        if (name !== "drawperiod" && cnt <= parameters.maxOccupiedDaysInEmptyWeek) {
            name = 'empty';
        }

        if (arr['withoutprices'] > cnt) {
            name = 'withoutprices';
        }

        return name;
    }

    var getCalendar = function (startdate, enddate, houseId, elementId, domain) {
        $.ajaxSetup({ cache: false });
        $.getJSON('/api/overview/GetReservationsForHouse?houseId=' + houseId + '&startdate=' + startdate.formatDate("yy-mm-dd") + '&enddate=' + enddate.formatDate("yy-mm-dd"), function(reservations) {

            var dayInUse = startdate;

            var cnt = 0;
            var output = '';
            var currentWeek;
            var lastYear = 0;
            var currentYear;
            while (dayInUse <= enddate) {
                currentWeek = dayInUse.getWeek();


                var week = '<div data-dayinuse="' + dayInUse.formatDate("yy-mm-dd") + '" class="week [COLOR]">' + currentWeek + '[DAYS]</div>';
                var days = '<div class="daysRow">';

                // color counter
                var colorCount = {
                    'reservation': 0,
                    'drawperiod':0,
                    'locked':0,
                    'booking':0,
                    'bookingmedium':0,
                    'bookinghard':0,
                    'reservationbyme':0,
                    'empty': 0,
                    'withoutprices' : 0
                };

                var isDrawperiodDay = 0;

                for (var i = 0; i < 7; i++) {
                    var colorClass = "empty";
                    var cssclass = 'day';
                    if (i === 6) {
                        cssclass = 'day last';
                    }else if (i === 0) {
                        cssclass = 'day first';
                    }

                    // get day color
                    var filter = $.grep(reservations, function (n) {
                        if (n.parsedStartdate === undefined) {
                            //TODO: "Datospænd hvor der er åbent i kalenderen" udlæser datoen i formatet "2014-03-04T00:00:00+01:00". Nedenstående hakker "+01:00" af - men burde nok håndteres der, hvor datoen sættes ind.
                            var tmp = n.startdate.split("+");
                            var tmp2 = n.enddate.split("+");
                            n.parsedStartdate = Date.parse(tmp[0]).getDateWithoutTime();
                            n.parsedEnddate = Date.parse(tmp2[0]).getDateWithoutTime();
                        }
                        return n.parsedStartdate <= dayInUse && n.parsedEnddate >= dayInUse;
                    });

                    if (filter.length > 0) {
                        // Tjek om reservation
                        if (filter[0].type === 1) {
                            colorClass = "reservation";
                        } else if (filter[0].type === -1) { // <-- Tjek om lodtrækningsperiode
                            colorClass = "drawperiod";
                        }

                        if (countTypesInArray(filter, 2) > 0) {
                            colorClass = "locked";
                        }

                        // ekstra tjek for reservationer. Virkede ikke altid hos spejderne nemlig..
                        if (countTypesInArray(filter, 1) > 0) {
                            colorClass = "reservation";
                        }

                        // Tjek om booking
                        if (colorClass !== "reservation" && filter.length > 2 && isAllTypesInArray(filter, 0, -1, -5)) {
                            colorClass = "booking";
                            var bookingCount = countTypesInArray(filter, 0);
                            if (bookingCount > parameters.minBookingborder && bookingCount <= parameters.mediumBookingborder) {
                                colorClass += "medium";
                            } else if (bookingCount > parameters.mediumBookingborder) {
                                colorClass += "hard";
                            }
                        }

                        if (colorClass === "reservation" && filter[0].userId === parameters.userId) {
                            colorClass = "reservationbyme";
                        }

                        if (colorClass === "drawperiod") {
                            isDrawperiodDay = 1;
                        }
                        // Tjek for ingen priser
                        if (filter.length === countTypesInArray(filter, -2) || (filter.length > 1 && filter.length === (countTypesInArray(filter, -2) + isDrawperiodDay))) {
                            colorClass = "withoutprices";
                        }
                    }
                    // get day color done
                    colorCount[colorClass]++;

                    days += '<div class="' + cssclass + ' ' + colorClass + '"></div>';
                    

                    dayInUse = dayInUse.addDays(1);
                }
                days += '</div>';
                week = week.replace('[DAYS]', days);

                var result = sortColorclasscollection(colorCount);
                week = week.replace('[COLOR]', result);

                // tjek om det er et nyt år
                currentYear = dayInUse.getFullYear();
                if (lastYear !== currentYear) {
                    lastYear = currentYear;

                    output += '<div class="year" data-year="' + dayInUse.formatDate("yy") + '">' + lastYear + '</div>';
                }

                // deadlock check
                if (cnt > 1000) {
                    break;
                }

                if (result !== "withoutprices") {
                    if (parameters.skipEmptyWeeksThisYear === true && currentYear === new Date().getFullYear() && (7-colorCount["empty"]) < parameters.maxOccupiedDaysInEmptyWeek) {
                        continue;
                    }
                    if (parameters.skipEmptyWeeksNextYear === true && currentYear === new Date().getFullYear() + 1 && (7-colorCount["empty"]) < parameters.maxOccupiedDaysInEmptyWeek) {
                        continue;
                    }
                    output += week;
                }
            }

            $('#' + elementId).html(output);

            // set klik events på
            $('#' + elementId + ' .week').click(function () {
                var datestr = $(this).attr('data-dayinuse');
                var date = new Date(datestr.split('-')[0], datestr.split('-')[1] - 1, datestr.split('-')[2]);
                date = date.addDays(4); // <-- vi vil gerne lande på en fredag..
                //location.href = domain + '/book_object_new.aspx?hid=' + houseId + '&year=' + date.getFullYear() + '&month=' + (date.getMonth() + 1) + '&day=' + date.getDate() + '&ref=catalog.aspx!pIndex=1';
                location.href = domain + '/book/' + houseId + '?date=' + date.formatDate("dd-mm-yy");
            });
            $('#' + elementId + ' .year').click(function () {
                var datestr = $(this).attr('data-year');
                var date = new Date(datestr, 0, 1);
                //location.href = domain + '/book_object_new.aspx?hid=' + houseId + '&year=' + date.getFullYear() + '&month=' + (date.getMonth() + 1) + '&day=' + date.getDate() + '&ref=catalog.aspx!pIndex=1';
                location.href = domain + '/book/' + houseId + '?date=' + date.formatDate("dd-mm-yy");
            });
        });
    }

    // public members
    return {
        Start: function (startdate, enddate, houseId, elementId, domain, optionalParameters) {
            if (optionalParameters != undefined) {
                parameters.minBookingborder = optionalParameters.minBookingborder;
                parameters.mediumBookingborder = optionalParameters.mediumBookingborder;
                parameters.locale = optionalParameters.locale;
                parameters.skipEmptyWeeksNextYear = optionalParameters.skipEmptyWeeksNextYear;
                parameters.skipEmptyWeeksThisYear = optionalParameters.skipEmptyWeeksThisYear;
                parameters.userId = optionalParameters.userId;
                parameters.maxOccupiedDaysInEmptyWeek = optionalParameters.maxOccupiedDaysInEmptyWeek;
            }


            // find første dag i start ugen
            while (startdate.getDay() !== 1) {
                startdate = startdate.addDays(-1);
            }

            // find sidste dag i slut ugen
            while (enddate.getDay() !== 0) {
                enddate = enddate.addDays(1);
            }

            getCalendar(startdate, enddate, houseId, elementId, domain);
        }
    }
})();